export default __webpack_public_path__ + "static/media/tickets-yellow-bg.81a0d24a.svg";